document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const input = document.querySelector(
      '[data-type="onetime-purchase"] input'
    );
    console.log('----------------input',input);
    if (input) {
      input.click();
    }
  }, 300); // ⏱ adjust delay if needed (300–1000ms is typical)
});

document.addEventListener("DOMContentLoaded", function () {
  const purchaseOptions = document.querySelectorAll(".purchase-option");
  const optionButtons = document.querySelectorAll(".optionButton");

  purchaseOptions.forEach(option => {
    option.addEventListener("click", function () {
      const selectedOption = this.dataset.option; // addtocart | subscribesave

      /* ---- Toggle purchase-option active ---- */
      purchaseOptions.forEach(o => {
        o.classList.remove("active");
        o.setAttribute("aria-checked", "false");
      });

      this.classList.add("active");
      this.setAttribute("aria-checked", "true");

      /* ---- Toggle CTA buttons ---- */
      optionButtons.forEach(btn => btn.classList.remove("active"));

      const targetButton = document.querySelector(
        `.optionButton.${selectedOption}`
      );
      if (targetButton) {
        targetButton.classList.add("active");
      }

      /* ---- NEW TWIST: Auto click based on data-option ---- */
      if (selectedOption === "subscribesave") {
        const subscriptionEl = document.querySelector(
          '[data-type="subscription-purchase"] input'
        );
        subscriptionEl?.click();
      }

      if (selectedOption === "addtocart") {
        const oneTimeEl = document.querySelector(
          '[data-type="onetime-purchase"] input'
        );
        oneTimeEl?.click();
      }

          
      /* ---- NEW TWIST: Replace variant group class ---- */
      const variantGroup = document.querySelector(".product-form__controls-group1");
      const purchaseFooter = document.querySelector(".purchase-footer");
      
      if (variantGroup) {
        variantGroup.classList.remove("onetime", "subscribesave");

        if (selectedOption === "addtocart") {
          variantGroup.classList.add("onetime");
        }

        if (selectedOption === "subscribesave") {
          variantGroup.classList.add("subscribesave");
        }
      }

      if (purchaseFooter) {
        purchaseFooter.classList.remove("onetime", "subscribesave");

        if (selectedOption === "addtocart") {
          purchaseFooter.classList.add("onetime");
        }

        if (selectedOption === "subscribesave") {
          purchaseFooter.classList.add("subscribesave");
        }
      }

    });
  });

  // const addtocart = document.querySelector(".optionButton.addtocart");
  const subscribesave = document.querySelector(".optionButton.subscribesave");

  // addtocart.addEventListener("click", function () {
  //   document.getElementById("atc_pdp_fold")?.click();
  // });

  subscribesave.addEventListener("click", function () {
    document.querySelector('[data-recurpay-action]')?.click();
  });
});

  document.addEventListener("DOMContentLoaded", function () {
    const purchaseOptions = document.querySelectorAll(".purchase-option");
    const variantOptions = document.querySelectorAll(".variant-option");

    function formatPrice(number) {
      return "₹" + number.toLocaleString("en-IN");
    }

    function getActivePurchaseType() {
      return document.querySelector(".purchase-option.active")?.dataset.option;
    }

    function updateAllVariantPrices() {
      const purchaseType = getActivePurchaseType();

      variantOptions.forEach(variant => {
        const input = variant.querySelector('input[name="packs"]');
        const aspEl = variant.querySelector(".variant-asp");

        if (!input || !aspEl) return;

        // Store original price once
        if (!aspEl.dataset.originalPrice) {
          aspEl.dataset.originalPrice = aspEl.innerText.replace(/[₹,]/g, "");
        }

        const originalPrice = parseInt(aspEl.dataset.originalPrice, 10);

        if (purchaseType === "subscribesave") {
          const discountPercent = parseInt(
            input.dataset.discount.replace("%", ""),
            10
          );

          const discountedPrice = Math.round(
            originalPrice - (originalPrice * discountPercent) / 100
          );

          aspEl.innerText = formatPrice(discountedPrice);
        } else {
          aspEl.innerText = formatPrice(originalPrice);
        }
      });
    }

    // Purchase option click
    purchaseOptions.forEach(option => {
      option.addEventListener("click", function () {
        purchaseOptions.forEach(o => o.classList.remove("active"));
        this.classList.add("active");
        updateAllVariantPrices();
      });
    });

    // Initial load
    updateAllVariantPrices();
  });

  document.addEventListener("DOMContentLoaded", function () {
    const youSaveEls = document.querySelectorAll(".yousaveExtraSave");
    const purchaseOptions = document.querySelectorAll(".purchase-option");

    function isSubscribeActive() {
      return document.querySelector(
        '.purchase-option.active[data-option="subscribesave"]'
      );
    }

    function updateYouSave() {
      const checkedInput = document.querySelector('input[name="packs"]:checked');
      if (!checkedInput || !youSaveEls.length) return;

      // ❌ Stop if not subscribe & save
      if (!isSubscribeActive()) {
        return;
      }

      const discount = checkedInput.getAttribute("data-discount");

      if (discount) {
        youSaveEls.forEach(el => {
          el.textContent = discount;
        });
      }
    }

    /* -------- Initial load -------- */
    updateYouSave();

    /* -------- Variant change -------- */
    document.querySelectorAll('input[name="packs"]').forEach(input => {
      input.addEventListener("change", updateYouSave);
    });

    /* -------- Purchase option change -------- */
    purchaseOptions.forEach(option => {
      option.addEventListener("click", function () {
        setTimeout(updateYouSave, 50);
      });
    });
  });

    document.addEventListener("DOMContentLoaded", function () {
    const supplyEl = document.querySelector(".supply");
    const supplyPriceEl = document.querySelector(".supplyprice");
    const purchaseOptions = document.querySelectorAll(".purchase-option");

    function updateSupply() {
      const checkedInput = document.querySelector('input[name="packs"]:checked');
      if (!checkedInput) return;

      const variantOption = checkedInput.closest(".variant-option");
      if (!variantOption) return;

      const title = variantOption.querySelector(".variant-title")?.innerText;
      const price = variantOption.querySelector(".variant-asp")?.innerText;

      if (supplyEl && title) supplyEl.textContent = title;
      if (supplyPriceEl && price) supplyPriceEl.textContent = price;
    }

    /* ---------- Initial load ---------- */
    updateSupply();

    /* ---------- Variant change ---------- */
    document.querySelectorAll('input[name="packs"]').forEach(input => {
      input.addEventListener("change", function () {
        setTimeout(updateSupply, 50); // small delay for price update
      });
    });

    /* ---------- Purchase option click ---------- */
    purchaseOptions.forEach(option => {
      option.addEventListener("click", function () {
        setTimeout(updateSupply, 300); // wait for subscribe price logic
      });
    });
  });

  purchaseOptions.forEach(option => {
    option.addEventListener("click", function () {
      const selectedOption = this.dataset.option; // addtocart | subscribesave

      const stickyBtn = document.getElementById("stickyAddToCartBtnATC");
      const mainAtcBtn = document.getElementById("atc_pdp_fold");
      const mainAtc = document.getElementById("atc_pdp_fold");

      /* ---- NEW TWIST: Auto click based on data-option ---- */
      if (selectedOption === "subscribesave") {
        const subscriptionEl = document.querySelector(
          '[data-type="subscription-purchase"] input'
        );
        subscriptionEl?.click();

        stickyBtn.addEventListener("click", function (e) {
          e.preventDefault();
          mainAtc.click();
        });
      }

      if (selectedOption === "addtocart") {   
        if (!stickyBtn || !mainAtcBtn) return;
        stickyBtn.addEventListener("click", function (e) {
          e.preventDefault();
          mainAtcBtn.click();
        });
      }
    });
  });